import superviseContractApi from '@/api/park/superviseContract';
export default {
  data() {
    return {
      withdrawalType: '',
    };
  },
  methods: {
    chooseClick(type) {
      if (!this.isCheckCurrentCompanyBelongParkCompany()) {
        this.$message.error('当前公司不支持该操作');
        return;
      }
      try {
        console.log(type);
        this[type]();
      } catch (e) {
        console.error('当前方法不支持', e);
        this.$message.error(`${type}当前方法不支持,请联系开发人员`);
      }
    },
    // 新增的方法
    addHandler() {
      this.$refs.siruiTable.clearCheckboxReserve();
      this.linkToPath('detail', '监管合同维护', 'create');
    },
    // 关闭方法
    async closeHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { id, contractStatus } = rowData;
      if (['01', '02', '04', '06'].includes(contractStatus)) {
        this.$message.error('当前合同状态不支持关闭');
      } else {
        await this.getSettlementList();
        console.log('shifou chuangjian', this.isCreate);
        this.$refs.closeContractDialogRef.openDialog(
          id,
          contractStatus,
          this.isCreate,
          this.isPaid
        );
      }
    },
    // 补充协议
    supplementAgreementHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus } = rowData;
      if (contractStatus != '03') {
        this.$message.error('当前合同状态不支持补充协议');
        return;
      }
      this.linkToPath('agreement', '补充协议', 'editAgreement');
    },
    // 撤回
    async withdrawHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { id, contractStatus } = rowData;
      if (contractStatus == '03') {
        this.withdrawalType = 'fail';
        this.$refs.withdrawalDialogRef.openDialog(rowData);
        return;
      }
      if (contractStatus != '02') {
        this.$message.error('当前状态不能撤回');
        return;
      }
      this.$confirmAction('撤销提示', '你确定要撤销吗').then(async () => {
        const { data } = await this.$axios.post(
          `${superviseContractApi.WITHDRAWAL_CONTRACT}/${id}`
        );
        if (data.code == 0) {
          this.withdrawalType = 'success';
          this.$refs.withdrawalDialogRef.openDialog();
        } else {
          this.$message.error('撤回失败');
        }
      });
    },
    // 删除
    deleteHandler() {
      if (!this.selectionList.length) {
        this.$message.error('请选择要删除的行');
        return;
      }
      const idList = this.selectionList.map((item) => item.id);
      const isDelete = this.selectionList.every((item) =>
        ['01', '04'].includes(item.contractStatus)
      );
      if (!isDelete) {
        this.$message.error('只有保存和驳回的单才可以删除');
        return;
      }
      this.$confirmAction('删除提示', '删除后将不可恢复，您确定要删除吗？')
        .then(async () => {
          const { data } = await this.$axios.post(`${superviseContractApi.DELETE_CONTRACT_BY_ID}`, {
            ids: idList,
          });
          if (data.code == 0) {
            this.$message.success('删除成功');
            this.resetBtnClick();
          } else {
            this.$message.error('删除成功');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 导出
    async exportHandler() {
      const idList = this.selectionList.map((item) => item.id);
      if (!idList.length) {
        this.$message.error('选择范围过大，请勾选后数据再导出数据');
        return;
      }
      this.isLoading = true;
      const { data } = await this.$axios.post(
        superviseContractApi.EXPORT_SUPERVISE_CONTRACT_EXCEL,
        { ids: idList }
      );
      this.isLoading = false;
      if (data.code === 0) {
        window.location.href = data.data;
        this.$message.success('导出成功');
      } else {
        this.$message.error('导出失败');
      }
    },
    // 审批
    approvalHandler() {
      this.approvalOrRejectHandler(1);
    },
    // 驳回按钮事件
    rejectHandler() {
      this.approvalOrRejectHandler(2);
    },
    approvalOrRejectHandler(type) {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus } = rowData;
      if (contractStatus != '02') {
        this.$message.error('只有待审批的单才可以操作');
        return;
      }
      this.$refs.approvalDialogRef.openDialog({ ...rowData, type });
    },
    // 续签
    renewHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus, contractNo, id } = rowData;
      if (contractStatus != '06') {
        this.$message.error('当前合同状态不支持续签');
        return;
      }
      const path = {
        path: '/park/superviseContract/renew',
        name: 'renew',
        meta: {
          keepAlive: false,
          title: '监管合同续签',
        },
        query: {
          status: 'renew',
          contractNo,
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 变更主体
    changeHandler() {
      // 先走关闭,再复制一份合同出来生成一份新的
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      this.changeRowData = rowData; // 特殊保存下当前选中变更主体的行
      const { contractStatus } = rowData;
      if (contractStatus != '03') {
        this.$message.error('当前合同状态不支持变更主体');
        return;
      }
      this.closeHandler();
    },
    // 变更合同信息
    changeContractHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const rowData = this.selectionList[0];
      const { contractStatus, contractNo, id } = rowData;
      if (contractStatus != '03') {
        this.$message.error('当前合同状态不支持变更合同信息');
        return;
      }
      const path = {
        path: '/park/superviseContract/change',
        name: 'change',
        meta: {
          keepAlive: false,
          title: '监管合同信息变更',
        },
        query: {
          status: 'change',
          contractNo,
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 复制
    copyHandler() {
      if (!this.checkSelectOneData()) {
        return;
      }
      const row = this.selectionList[0];
      const { contractStatus, contractNo, id } = row;
      console.log(row, '双击行', contractStatus, contractNo, id);
      const name = 'detail';
      const path = {
        path: `/park/superviseContract/${name}`,
        name: name,
        meta: {
          keepAlive: false,
          title: '监管合同维护',
        },
        query: {
          status: 'create',
          contractNo: contractNo ? contractNo : '',
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 选择一行判断
    checkSelectOneData() {
      if (!this.selectionList.length) {
        this.$message.error('请选择一行操作');
        return false;
      }
      if (this.selectionList.length != 1) {
        this.$message.error('只能选择一行操作');
        return false;
      }
      return true;
    },
    // 内部使用跳转地址
    linkToPath(name, title, status) {
      const rowData = this.selectionList[0];
      const { id, contractNo } = rowData || { contractNo: '', id: '' };
      const path = {
        path: `/park/superviseContract/${name}`,
        name: name,
        meta: {
          keepAlive: false,
          title: title,
        },
        query: {
          status: status,
          contractNo,
          id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
  },
};
